import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Smartphone, Wifi, Battery, Monitor, Zap, Shield } from 'lucide-react';

const MobileGamingGuide = () => {
  return (
    <div className="min-h-screen bg-book-cream">
      <Header />
      <main className="book-section">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-book-brown mb-6">
              Mobile Gaming Excellence
            </h1>
            <p className="text-xl text-book-brown-dark leading-relaxed">
              Unlock the full potential of mobile casino gaming with tips for optimal performance and seamless experiences.
            </p>
          </div>

          <div className="mb-16 bg-book-beige rounded-xl p-8 shadow-book-inset">
            <h2 className="text-2xl font-bold text-book-brown mb-6 text-center">Our Guide Writing Philosophy</h2>
            <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
              <p>Every guide published on Brit Ember represents extensive research and deep industry insights...</p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-6">The Mobile Gaming Revolution</h2>
            <p>Mobile gaming represents the most significant evolution in casino entertainment...</p>
          </div>

          <div className="mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-8 text-center">Mobile Gaming Performance Analytics</h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Device Market Share</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">iOS Devices</span>
                    <span className="font-semibold text-book-brown">68%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Android Devices</span>
                    <span className="font-semibold text-book-brown">32%</span>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Connection Quality Impact</h3>
                <div className="space-y-4">
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">5G Networks</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '95%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">95%</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">4G Networks</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-yellow-500 h-3 rounded-full" style={{width: '75%'}}></div>
                      </div>
                      <span className="font-semibold text-yellow-600">75%</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">3G Networks</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-red-500 h-3 rounded-full" style={{width: '45%'}}></div>
                      </div>
                      <span className="font-semibold text-red-600">45%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Battery Performance</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Modern Smartphones</span>
                    <div className="w-16 bg-green-500 rounded-full h-3"></div>
                    <span className="font-semibold text-green-600">4-6 hours</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Older Devices</span>
                    <div className="w-12 bg-yellow-500 rounded-full h-3"></div>
                    <span className="font-semibold text-yellow-600">2-3 hours</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">With Power Bank</span>
                    <div className="w-20 bg-green-500 rounded-full h-3"></div>
                    <span className="font-semibold text-green-600">8+ hours</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
            <p>Mobile gaming represents the most significant evolution in casino entertainment...</p>
            <div className="bg-book-beige rounded-lg p-6 my-8">
              <h4 className="text-xl font-bold text-book-brown mb-4">Essential Mobile Gaming Principles</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <Smartphone className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Choose casinos with dedicated mobile apps or responsive design</span>
                </li>
                <li className="flex items-start">
                  <Wifi className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Ensure stable internet connection for optimal performance</span>
                </li>
                <li className="flex items-start">
                  <Battery className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Monitor battery life and have charging solutions available</span>
                </li>
                <li className="flex items-start">
                  <Shield className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Use secure networks and avoid public Wi-Fi for financial transactions</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MobileGamingGuide;
